<template>
  <div class="jewel-article-page">
    <catalog-jewel-article v-bind:jewel="jewel"></catalog-jewel-article>
  </div>
</template>

<script>
import CatalogJewelArticle from '../components/the-content/CatalogJewelArticle'
import utils from './utils'

export default {
  name: 'CatalogJewelPage',
  components: {CatalogJewelArticle},
  data () {
    return {
      jewel: {},
      canonicalCategory: this.$route.params.category
    }
  },
  computed: {
    title: function () {
      const title = this.jewel.title
      const code = this.jewel.vendor_code ? this.jewel.vendor_code : this.jewel.note
      return (title && code) ? `${title} ${code}` : ''
    },
    metaDescription: function () {
      let title = this.title.toLowerCase()
      title = title.replace(/^([a-я]+)а([^а-я]*)/, '$1у$2')
      title = title.replace(/^([a-я]+)я([^а-я]*)/, '$1ю$2')

      let descParts = ['Купить']
      descParts.push(title)
      if (this.jewel.material) {
        descParts.push(`(${this.jewel.material})`)
      }
      descParts.push('от ювелирной фирмы «Стиль» в Бресте')
      return descParts.join(' ')
    },
    canonicalHref: function () {
      let route = this.$route
      if (this.canonicalCategory !== this.$route.params.category) {
        let params = Object.assign({}, this.$route.params)
        params.category = this.canonicalCategory
        route = {name: 'CatalogJewelPage', params: params}
      }
      return this.$router.resolve(route).href
    },
    linkTags: function () {
      let linksList = []
      if (this.canonicalCategory !== this.$route.params.category) {
        linksList.push({
          rel: 'canonical',
          href: utils.addDomainToPath(this.canonicalHref)
        })
      }
      return linksList
    },
    imageForMeta: function () {
      return (this.jewel.images) ? this.jewel.images[0] : {}
    }
  },
  metaInfo () {
    return {
      title: this.title,
      link: this.linkTags,
      meta: utils.getDefaultMetaTags({
        description: this.metaDescription,
        path: this.canonicalHref,
        title: this.title,
        imageUrl: this.imageForMeta.image
      })
    }
  },
  mounted () {
    this.getJewel(this.$route.params.jewel)
  },
  watch: {
    $route (to, from) {
      this.getJewel(this.$route.params.jewel)
    }
  },
  methods: {
    getJewel: function (alias) {
      const uri = `${process.env.API_HOST}/api/v1/catalog/get-jewel/${alias}`
      let uriParams = Object.assign({}, this.$route.params)
      delete uriParams.jewel

      this.$http
        .get(uri, {params: uriParams})
        .then(response => {
          this.jewel = response.body
          this.canonicalCategory = this.jewel.category[0]
        })
        .catch(error => {
          console.log(error)
          this.$router.replace({name: 'Page404'})
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/CatalogJewelPage.vue